import Axios from 'axios';

const baseEndpoint: string = window.momentaMaisService.base;

class ConfigurationService {

    static getConfiguration = async (key: string) => {
        var md5 = require('md5');
        key = md5(key);
        var retorno =  await Axios.get(`${baseEndpoint}${window.momentaMaisService.configuration}/${key}`);

        return retorno.data.data;
    }
}

export default ConfigurationService;